import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoginOptionsComponent } from "../../shared/login-options/login-options.component";
import { LoginComponent } from "../../shared/login/login.component";
import { SignupComponent } from "../../shared/signup/signup.component";
import { SharedModule } from "../shared/shared.module";

import { DesignSystemModule } from "../../design-system";
import { ResetEmailComponent } from "../../profile/reset-email/reset-email.component";

@NgModule({
    imports: [CommonModule, SharedModule, DesignSystemModule, LoginOptionsComponent,
    LoginComponent,
    SignupComponent,
    ResetEmailComponent],
    exports: [
        LoginOptionsComponent,
        LoginComponent,
        SignupComponent,
        ResetEmailComponent,
    ]
})
export class LoginModule {}
